import { ChangeDetectorRef, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { AccountService } from '../services/account.service';
import { NavigationService } from '../services/navigation.service';
import { ActivatedRoute, Router, NavigationEnd, NavigationStart } from '@angular/router';
import { MessageService } from 'primeng/api';
import { distinctUntilChanged, filter, Subscription } from 'rxjs';
import { ApplicationInsightsService } from '../services/application-insights.service';
import { DomSanitizerService } from '../services/dom-sanitizer.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit,OnDestroy {
  interval = null;
  showLeftNav: boolean = false;
  showTopNav: boolean = false;
  showRightNav: boolean = false;
  backgroundColor: string = '#EBEBEB';
  letNavSelected = null;
  showNav: boolean = false;
  hideNavRoutes = [
    'login',
    'changepassword',
    'resetpassword',
    'terms',
    'reset',
    'admin',
    'verify-otp',
    '2fa-sms-verification'
  ];
  subscription: Subscription;
  browserRefresh = false;
  constructor(private accountService: AccountService,
    private navigationService: NavigationService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private renderer: Renderer2,
    private messageService: MessageService,
    private applicationInsights: ApplicationInsightsService,
    private domSanitizer: DomSanitizerService) {
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.browserRefresh = !router.navigated; 
        if (this.browserRefresh && event.url.includes('/invoices/') && !event.url.includes('/invoices/active')) {
          this.router.navigate(['/invoices/active']);
          this.navigationService.setLeftNav(null, "invoices");
        }
      }
    });
  }

  clear() {
    this.messageService.clear();
  }

  ngOnInit() {
    // Initialize runtime DOM XSS protection
    this.domSanitizer.initialize();

    // Initialize Application Insights tracking
    this.applicationInsights.trackPageView('App Initialized');

    this.router.events
    .pipe(
      filter(event => event instanceof NavigationEnd),
      distinctUntilChanged((prev: NavigationEnd, curr: NavigationEnd) => prev.urlAfterRedirects === curr.urlAfterRedirects)
    )
    .subscribe((r: NavigationEnd) => {
      this.showNav = !this.hideNavRoutes.some(h => r.url.toLowerCase().startsWith('/' + h));
      
      // Track page views for each route
      this.applicationInsights.trackPageView(`Page: ${r.url}`, r.url);
      
      if (this.showNav) {
        this.navigationService.loadLeftNav();
      }
    });

    this.navigationService.showLeftNav$.subscribe(v => {
      this.showLeftNav = v;
    });

    this.navigationService.showTopNav$.subscribe(v => {
      this.showTopNav = v;
    });

    this.navigationService.leftNav$.subscribe(v => {
      this.letNavSelected = v;
      if (this.navigationService.getNav().leftNav.tab == 'search') {
        this.backgroundColor = '#E0E8F5';
      } else {
        this.backgroundColor = '#EBEBEB';
      }
    })

    this.switchMode();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.domSanitizer.destroy();
  }

  switchMode() {
    const isDarkMode = localStorage.getItem('isDarkMode');
    if (isDarkMode && isDarkMode === 'true') {
      this.renderer.addClass(document.body, 'dark-theme');
    } else {
      this.renderer.removeClass(document.body, 'dark-theme');
    }
  }
}
